import { memoFn } from "@phosphor/utils";
import type { PrimitiveAtom } from "jotai";
import { useAtom } from "jotai";
import React from "react";
import { atomWithLocalStorage } from "#scripts/lib/jotai/atomWithLocalStorage.ts";

/**
 * Returns an atom that indicates whether non-favorites are collapsed.
 * This is specific to the given devStateName.
 */
export const getCollapseNonFavoritesAtom = memoFn((devStateName: string): PrimitiveAtom<boolean> => {
  return atomWithLocalStorage<boolean>("dev-collapse-non-favorites:" + devStateName, false);
});

/**
 * Returns an atom that indicates whether only favorites should be shown
 * (others are hidden entirely).
 * This is specific to the given devStateName.
 */
export const getOnlyFavoritesAtom = memoFn((devStateName: string): PrimitiveAtom<boolean> => {
  return atomWithLocalStorage<boolean>("dev-only-favorites:" + devStateName, false);
});

export const ToggleAtomCheckbox = React.forwardRef<
  React.ElementRef<"input">,
  React.ComponentPropsWithoutRef<"input"> & {
    atom: PrimitiveAtom<boolean>;
  }
>(({ atom, ...props }, ref) => {
  const [value, setValue] = useAtom(atom);
  return <input ref={ref} type="checkbox" checked={value} onChange={(e) => setValue(e.target.checked)} {...props} />;
});
ToggleAtomCheckbox.displayName = "ToggleAtomCheckbox";
